"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENVIRONMENTS = exports.ENVIRONMENT_NAMES = void 0;
exports.ENVIRONMENT_NAMES = [
    "testnet",
    "mainnet",
    "dev",
    "test",
];
exports.ENVIRONMENTS = {
    dev: {
        authIssuer: "http://localhost:8001",
        apiEndpoint: "http://localhost:10001/dev/graphql",
        flowAccessApi: "http://localhost:8888",
        walletApi: "http://localhost:8701/fcl/authn",
    },
    test: {
        authIssuer: "https://auth.test.niftory.com",
        apiEndpoint: "https://api.test.niftory.com/v1/graphql",
        flowAccessApi: "https://rest-testnet.onflow.org",
        walletApi: "https://flow-wallet-testnet.blocto.app/authn/",
    },
    testnet: {
        authIssuer: "https://auth.staging.niftory.com",
        apiEndpoint: "https://graphql.api.staging.niftory.com/",
        flowAccessApi: "https://rest-testnet.onflow.org",
        walletApi: "https://flow-wallet-testnet.blocto.app/authn/",
    },
    mainnet: {
        authIssuer: "https://auth.niftory.com",
        apiEndpoint: "https://graphql.api.niftory.com/",
        flowAccessApi: "https://mainnet.onflow.org",
        walletApi: "https://rest-mainnet.onflow.orgn",
    },
};
